import store from '@/store';
/* 
    工具
	import tools from "@/common/tools.js"
*/

export default {
    //ios终端
    isIos: function(){
        let u = navigator.userAgent;
        return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    },
    //android终端
    isAndroid: function(){
        let u = navigator.userAgent;
        return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
    },
    //微信
    isWx: function(){
        let u = navigator.userAgent;
        return u.indexOf('MicroMessenger') > -1;
    },
    //QQ
    isQQ: function(){
        let u = navigator.userAgent;
        return u.match(/\sQQ/i) == " qq";
    },
    //微信小程序
    isWxMiniApp: function(){
        return this.isWx() && window.__wxjs_environment === 'miniprogram';
    },
    //是否在亿动app
    isYdApp: function(){
        let u = navigator.userAgent;
        return u.indexOf('cesyd') > -1;
    },
	// 获取毫秒级时间戳 number
	timestamp: function() {
		return Date.now()
	},
	// 获取秒级时间戳 number
	secondTimestamp: function() {
		return Math.floor(this.timestamp() / 1000);
	},
    //ios原生交互
    setupWKWebViewJavascriptBridge: function(callback) {
        if(!this.isWxMiniApp()){
            if(window.webkit && window.webkit.messageHandlers){
                if (window.WKWebViewJavascriptBridge) { return callback(WKWebViewJavascriptBridge); }
                if (window.WKWVJBCallbacks) { return window.WKWVJBCallbacks.push(callback); }
                window.WKWVJBCallbacks = [callback];
                window.webkit.messageHandlers.iOS_Native_InjectJavascript.postMessage(null)
            }else{
                callback(null);
            }
        }else{
            callback(null);
        }
    },
    //获取app版本
    getAppVersion(){
        let appInfo = store.state.AppInfo;
        let nowVersion = appInfo.RequestNowVersion || "";
        return nowVersion.split('_')[1] || 0;
    },
    //判断app版本
    isVersion(v){
        return this.getAppVersion() >= v;
    },
    //rem计算实际px
    remToPx(rem){
        let fontsize = parseFloat(document.querySelector('html').style.fontSize);
        return rem / 100 * fontsize;
    },
    //导航栏高度
    getNavBarHeightWithInt: function(){
        return this.remToPx(88);
    },
    getNavBarHeight: function(){
        return this.getNavBarHeightWithInt() + 'px';
    },
    //页面标题高度
    getTitleHeightWithInt: function(){
        return this.remToPx(188);
    },
    getTitleHeight: function(){
        return this.getTitleHeightWithInt() + 'px';
    },
    //滚动阴影
    setScrollShadow: function(value){
        if(typeof value == 'boolean' && value){
            return { boxShadow: `0 0.04rem 0.12rem 0.02rem rgba(216,220,228,0.76)` };
        }else if(value > 0){
            let n = value / 260 * 0.76;
            n = n > 0.76 ? 0.76 : n;
            return { boxShadow: `0 0.04rem 0.12rem 0.02rem rgba(216,220,228,${n})` };
        }else{
            return {};
        }
    },
    //获取zindex 正向
    getZIndex: function(){
        let zIndex = window.ZINDEX || 1000;
        zIndex++;
        window.ZINDEX = zIndex;
        return zIndex;
    },
    //读取非常规时间格式
    getAbnormalDate: function(value, fmt = 'yyyy年MM月dd日'){
		if(!['yyyy年MM月dd日', 'yyyy-MM-dd'].includes(fmt))return;
		let dateText = '';
		if(typeof value == 'number'){
			let dateStr = value.toString();
			let year = dateStr.substr(0,4),
				month = dateStr.substr(4,2),
				day = dateStr.substr(6,2);
			let dates = [];
			if(+year){ dates.push(year); }
			if(+month){ dates.push(month); }
			if(+day){ dates.push(day); }
			if(fmt == 'yyyy年MM月dd日'){
				let b = '年月日';
				dateText = dates.map((item,index)=>item + b[index]).join('');
			}else{
				dateText = dates.join('-');
			}
		}
		return dateText;
	},
    //时间格式化
    dateFormat: function(date,fmt){
        if(typeof date != 'object')date = new Date(date.replace(/-/g,'/').replace(/T|Z/g,' '));
        if(date == 'Invalid Date'){
            return '';
        }else{
            return (function (fmt){
                var o = {
                    "M+": this.getMonth() + 1,
                    "d+": this.getDate(),
                    "H+": this.getHours(),
                    "h+": this.getHours(),
                    "m+": this.getMinutes(),
                    "s+": this.getSeconds(),
                    "q+": Math.floor((this.getMonth() + 3) / 3),
                    "S": this.getMilliseconds()
                };
                fmt = fmt || "yyyy-MM-dd";
                if (/(y+)/.test(fmt))
                    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
                let HoursStyle = [],hoursText='';
                if(new RegExp("(12H)").test(fmt)){
                    HoursStyle = ['AM','PM'];
                }else if(new RegExp("(12h)").test(fmt)){
                    HoursStyle = ['am','pm'];
                }
                if(HoursStyle.length > 0){
                    let hours = parseInt(date.getHours());
                    if(hours == 0){
                        hoursText = '12' + HoursStyle[0];
                    }else{
                        hoursText = hours >= 12 ? (hours-12 + HoursStyle[1]) : (hours + HoursStyle[0]);
                    }
                    fmt = fmt.replace(RegExp.$1, 'EE');
                }
                for (var k in o)
                    if (new RegExp("(" + k + ")").test(fmt))
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                fmt = fmt.replace('EE', hoursText);
                return fmt;
            }).call(date,fmt);
        }
    },
    //信息隐藏
    encryption: function(text, start = 0, end = 0, symbol = '...'){
        if(!text || (start == 0 && end == 0)) return text;
        return text.replace(new RegExp(`^.{${start}}([\\s\\S]*?).{${end}}$`,'ig'),function(p1, p2){
            if(p2){
                return text.replace(p2,symbol);
            }else{
                return text;
            }
        });
    },
    //高亮文本中的文字
    highlight: function(text, need){
        const reg = new RegExp(need,'gi');
        return text.replace(reg,(matching)=>{
            return `<i style="font-style: normal;color: #7AD21A">${matching}</i>`;
        });
    },
    //添加省略号
    ellipsis: function(value,length){
        if(value && value.length > length){
            return value.substr(0,length)+'...';
        }else {
            return value;
        }
    },
    formatFileSize(fileSize) {
        if(!fileSize) return '';
        if (fileSize < 1024) {
            return fileSize + 'B';
        } else if (fileSize < (1024*1024)) {
            var temp = fileSize / 1024;
            temp = temp.toFixed(2);
            return temp + 'KB';
        } else if (fileSize < (1024*1024*1024)) {
            var temp = fileSize / (1024*1024);
            temp = temp.toFixed(2);
            return temp + 'MB';
        } else {
            var temp = fileSize / (1024*1024*1024);
            temp = temp.toFixed(2);
            return temp + 'GB';
        }
    }
}